<style lang="scss">
@import "../styles/payment-v2/payment-form.scss";
</style>

<template>
  <v-select
    outline
    :label="this.$t('$onboarding.fields.placeholders.select_card')"
    :value="selectedCard"
    @input="onSelectCreditCard"
    :items="creditCards"
    append-icon="$vuetify.icons.expand"
    attach="select-container"
    hide-details
  ></v-select>
</template>

<script>
// Mappings
import { Constants } from "customer-sdk/constants";

const PAYMENT_METHODS_EVENTS = Constants.ON_BOARDING_PAYMENT_METHODS_EVENTS;

//#region private methods
let publishAddCardSelected = (component, selectedCard) => {
  let { paymentMethodsTopic } = component;
  if (paymentMethodsTopic) {
    paymentMethodsTopic.publish({
      type: PAYMENT_METHODS_EVENTS.ON_ADD_NEW_CARD_SELECTED,
      data: { selectedCard }
    });
  }
};

let publishExistingCardSelected = (component, selectedCard) => {
  let { paymentMethodsTopic } = component;
  if (paymentMethodsTopic) {
    paymentMethodsTopic.publish({
      type: PAYMENT_METHODS_EVENTS.ON_EXISTING_CARD_SELECTED,
      data: { selectedCard }
    });
  }
};
//#endregion

export default {
  methods: {
    onSelectCreditCard: function(event) {
      const component = this;
      if (event === "add_card") {
        publishAddCardSelected(component, event);
      } else {
        publishExistingCardSelected(component, event);
      }
    }
  },
  props: {
    selectedCard: String,
    paymentMethodsTopic: Object,
    creditCards: Array
  }
};
</script>
